













































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import {
	RedCapital,
	SelectedCountry,
	TitleTemplateDashboard
} from "@/configuration";
import api from "@/api";
import { EventBus } from "@/main";
import ShowLoading from "@/components/panel/ShowLoading.vue";
import DniBusiness from "@/components/dniBusiness/DniFieldBusiness.vue";

import { isRutValid } from "@/utils";

type Banco = { id: number | string; nombre: string; };
type TipoCuenta = { id: number; nombre: string };
type OwnerType = { id: number; label: string; descripcion: string };

type FormModel = {
  titular: string | null;
  rut: string | null;
  banco: Banco | null;
  tipo_cuenta: TipoCuenta | null;
  numero_cuenta: string | null;
  tipo_duenio: number | null;
};

@Component({
	metaInfo() {
		return {
			title: "Cuenta bancaria",
			titleTemplate: TitleTemplateDashboard,
			htmlAttrs: {
				// @ts-ignore
				lang: RedCapital[SelectedCountry].Lang
			}
		};
	},
	components: { ShowLoading, DniBusiness },
})
export default class BankAccount extends Vue {
  canShow = false;
  valid = { form: false };
  isLoading = false;

  defaultTitular = "";
  defaultRut = "";

  companyTitular = "";
  companyRut = "";

  initialForm: FormModel | null = null;
  personalFormCache: FormModel | null = null;
  companyFormCache: FormModel | null = null;

  form: FormModel = {
    titular: null,
    rut: null,
    banco: null,
    tipo_cuenta: null,
    numero_cuenta: null,
    tipo_duenio: null,
  };

  reglas = {
    noVacio: (label: string) => [
      (v: string) => {
        const s = typeof v === "string" ? v.trim() : v;
        if (!s || s === "" || s === "0" || s === null) return `${label} es obligatorio`;
        return true;
      },
    ],
    noSelect: [
      (v: any) => (!!v && v !== 0 ? true : "Campo requerido"),
    ],
    noLetters: [
      (v: string) => {
        const regex = /^[0-9]*$/;
        if (v && !regex.test(v)) return "Sólo se permiten números";
        return true;
      },
    ],
  };

  bancos: Banco[] = [];
  cuentas: TipoCuenta[] = [];
  owners: OwnerType[] = [];

  firstTime = true;
  disabledName = false;
  blockedName = false;

  get setOpenMenuPanel() {
	  return this.$store.state.setOpenMenuPanel;
  }
  
  get isDisabled(): boolean {
	  return this.isLoading || !this.canPress || !this.isFormChanged;
  }

  get canPress(): boolean {
    return this.valid.form && this.rutIsValid;
  }

  get smallScreen(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get isCompanyAccount(): boolean {
    return this.form.tipo_duenio === 2;
  }

  get rutIsValid(): boolean {
    return this.form.rut !== null && this.form.rut !== '' && isRutValid(this.form.rut);
  }

  get isFormChanged(): boolean {
	if (!this.initialForm) return false;

	//@ts-ignore
	return Object.keys(this.form).some(key => JSON.stringify(this.form[key]) !== JSON.stringify(this.initialForm[key]));
  }

  @Watch('form.tipo_duenio')
  onOwnerTypeChange(newVal: number, oldVal: number) {
    if (this.firstTime || newVal == null) return;

    this.$nextTick(() => {
      const frm = this.$refs.formRef as Vue & { resetValidation: () => void };
      frm && frm.resetValidation();
    });

    this.form.banco = null;
    this.form.tipo_cuenta = null;
    this.form.numero_cuenta = '';

    if (newVal === 1) {
      this.form.titular = this.defaultTitular;
      this.form.rut = this.defaultRut;
    } else if (newVal === 2) {
      this.form.titular = '';
      this.form.rut = '';
    }

    if(this.initialForm && newVal == this.initialForm.tipo_duenio){
      this.form = { ...this.initialForm };
    }
  }

  async mounted() {
    await this.loadArrayData();
    await this.fillDataForm();
    this.canShow = true;
  }

  async validate() {
    (this.$refs.formRef as Vue & { validate: () => boolean }).validate();

    if (this.canPress) {
      await this.submitForm();
    }

    this.isLoading = false;
  }
  async submitForm() {
    this.isLoading = true;
    try {
      const payload = this.createPayload();
      const resp = await api.updNewBankAccount(payload);

      if (resp && resp.status === 201) {
        EventBus.$emit("snack-success", "Datos guardados correctamente.");
      } else {
        EventBus.$emit("snack-error", "Error al guardar los datos. Intenta nuevamente.");
      }
    } catch (error) {
      // @ts-ignore
		  const response = error.response;
      if(response && response.status === 422 && response.data){
        const errors = response.data.message || {};
        let validationMessages = '';
        for (const field in errors) {
          validationMessages += errors[field].join(' ') + ' ';
        }
        EventBus.$emit("snack-error", validationMessages.trim());
        return;

      }else{
        EventBus.$emit("snack-error", "Error al guardar los datos. Intenta nuevamente.");
      }
    } finally {
      this.isLoading = false;
    }
  }

  async loadArrayData() {
    this.bancos = await api.getBanks() as Banco[];
    this.cuentas = await api.getAccountTypes() as TipoCuenta[];

    const { data } = await api.getOwnerTypeBank();
    this.owners = data.data as OwnerType[];

    await this.loadDataBank();
  }

  async fillDataForm(){
   const { user } = this.$store.state;
    if(user){
      this.defaultTitular = user.nombre && user.app_pat  ? `${user.nombre} ${user.app_pat} ${user.app_mat || ''}` : '';
      this.defaultRut = user.rut || '';

      if(this.form.tipo_duenio === null || this.form.tipo_duenio === 1){
        this.form.titular = this.defaultTitular;
        this.form.rut = this.defaultRut;
      }else{
        this.form.titular = this.companyTitular;
        this.form.rut = this.companyRut || '';
      }
    }

	  this.initialForm = { ...this.form };
    console.log('Initial Form:', this.initialForm);
    this.firstTime = false;
  }

  async loadDataBank(){
    try {
      const res = await api.getUserBank() as any;
      
      this.form.banco = this.bancos.find(b => b.id === res.banco_id) || null;
      this.form.tipo_cuenta = this.cuentas.find(c => c.id === res.tipo_cuenta_id) || null;
      this.form.numero_cuenta = res.numero || null;

      const existsOwner = this.owners.find(o => o.id === res.tipo_duenio_id);
      this.form.tipo_duenio = existsOwner ? existsOwner.id : this.selectOwnerByDefault();

      if(existsOwner && existsOwner.id === 2){
        this.companyTitular = res.nombre_duenio || '';
        this.companyRut = res.rut_duenio || '';
      }

    } catch (error) {
      this.form.tipo_duenio = this.selectOwnerByDefault();
      return null;
    }
  }

  selectOwnerByDefault() {
    const personalAccount = 1;
    const owner = this.owners.find(o => o.id == personalAccount);
    if (owner) {
      return owner.id;
    } else {
      return null;
    }
  }
    
  createPayload() {
    const { form } = this.$data;
    const payload: Record<string, any> = {};

    for (const key in form) {
      const v = form[key];
      if (v === undefined || v === null) continue;

      if (key === "banco") {
        payload["banco_id"] =
          (typeof v === "object" && "id" in v) ? v.id : v;
        continue;
      }

      if (key === "tipo_cuenta") {
        payload["tipo_cuenta_id"] =
          (typeof v === "object" && "id" in v) ? v.id : v;
        continue;
      }

      if(key === "numero_cuenta"){
        payload['numero'] = v;
        continue;
      }

      if(key === "tipo_duenio"){
        payload['tipo_duenio_id'] = v;
        continue;
      }

      if(this.form.tipo_duenio === 2){
        if(key === "titular"){
          payload['nombre_duenio'] = v;
          continue;
        }
        if(key === "rut"){
          payload['rut_duenio'] = v;
          continue;
        }
      }

      payload[key] = v;
    }

    return payload;
  }

  dataResponseConsultando(data : any){
    if(data){
      this.blockedName = true;
    }else{
      this.blockedName = false;
    }
  }
  dataResponse(data : any){
    if(this.form.rut && parseInt(this.form.rut.split('.').join('').slice(0, 2)) > 35 && this.form.rut.split('.').join('').length >= 10){
      if(data.data.presenta_inicio_actividades == 'NO'){
        this.disabledName = false;
        this.form.titular = data.data.razon_social ? data.data.razon_social : '';
        
        if(this.form.titular !== ''){
         this.disabledName = true;
        }

      }else{ 
        this.disabledName = true;
        this.form.titular = data.data.razon_social;
      }
    } else {
      EventBus.$emit("snack-error", "El RUT ingresado no corresponde a una empresa.");
      this.disabledName = false;
      this.form.titular = null;
      this.form.rut = null;
    }
  }
  dataResponseVacio(){
    this.form.titular = null;
  }
}
